function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.65625 3.46875H8.375C8.52969 3.46875 8.65625 3.34219 8.65625 3.1875V3.46875H19.3438V3.1875C19.3438 3.34219 19.4703 3.46875 19.625 3.46875H19.3438V6H21.875V3.1875C21.875 1.94648 20.866 0.9375 19.625 0.9375H8.375C7.13398 0.9375 6.125 1.94648 6.125 3.1875V6H8.65625V3.46875ZM26.375 6H1.625C1.00273 6 0.5 6.50273 0.5 7.125V8.25C0.5 8.40469 0.626562 8.53125 0.78125 8.53125H2.90469L3.77305 26.918C3.8293 28.1168 4.8207 29.0625 6.01953 29.0625H21.9805C23.1828 29.0625 24.1707 28.1203 24.227 26.918L25.0953 8.53125H27.2188C27.3734 8.53125 27.5 8.40469 27.5 8.25V7.125C27.5 6.50273 26.9973 6 26.375 6ZM21.7098 26.5312H6.29023L5.43945 8.53125H22.5605L21.7098 26.5312Z",
  fill: "currentColor"
});

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.03b76aa6.svg";
export { ForwardRef as ReactComponent };